import { useQuery } from '@tanstack/react-query';

import { get } from '@eika-infrastruktur/request';

import { SearchParams, useSearchParam } from '@/domain/app';
import { useCreditCardDetails } from '@/domain/card';
import { KREDITTBANKEN_BASE_URL } from '@/react-query/common';

import { CreditCard, CreditCardReservation, CustomerRole } from '@generated-types';

export const cardNumberIfOwner = (card: CreditCard | undefined) => {
    return card?.cardHolder.role !== CustomerRole.ACCOUNT_OWNER ? card?.cardNumber : undefined;
};

const getCreditCardReservationsByAccount = async (accountId: string, cardNumber?: string) => {
    const params = cardNumber ? new URLSearchParams([['cardNumber', cardNumber]]).toString() : undefined;
    return get<CreditCardReservation[]>(
        `${KREDITTBANKEN_BASE_URL}/credit-card-accounts/${accountId}/reservations${params ? `?${params}` : ''}`,
    );
};

export const useCreditCardReservationsByAccount = () => {
    const accountId = useSearchParam(SearchParams.ACCOUNT_ID);
    const { data } = useCreditCardDetails();
    const cardNumber = cardNumberIfOwner(data);

    return useQuery<CreditCardReservation[]>({
        queryKey: ['v4', 'credit-card-account', accountId, 'reservations', cardNumber],
        queryFn: () => getCreditCardReservationsByAccount(accountId!, cardNumber),
        enabled: !!accountId,
    });
};
